import {TrustStatus} from '@sollapay/enums';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {
  TrustAccountBalancePanel,
  TrustAccountCardAction,
  TrustAccountGridCard,
  TrustAccountMoreMenu,
  TrustAccountNameCell,
  TrustAccountTypeCell
} from '@/features/trust-accounts/components';

import {GuestInviterCell} from './GuestInviterCell';
import {GUEST_ACCOUNT_MENU_ACTIONS} from '../config';

import type {GuestTrustAccountListItem} from '../utils';
import type {FC} from 'react';

export interface GuestAccountCardProps {
  item: GuestTrustAccountListItem;
}

/** The member card, read-only: the inviter in place of the team, and only a copy-number menu. */
export const GuestAccountCard: FC<GuestAccountCardProps> = ({item}) => {
  const {t} = useTranslation('guest');
  const navigate = useNavigate();

  return (
    <TrustAccountGridCard
      balance={
        item.trustStatus === TrustStatus.TRUST_ACTIVE && (
          <TrustAccountBalancePanel status={item.trustStatus} balance={item.balance} />
        )
      }
      identity={
        <TrustAccountNameCell
          variant="card"
          name={item.name}
          refId={item.refId}
          trustPurpose={item.trustPurpose}
          rowLinkTo={item.path}
        />
      }
      menu={
        <TrustAccountMoreMenu
          refId={item.refId}
          actions={GUEST_ACCOUNT_MENU_ACTIONS}
          orientation="vertical"
        />
      }
      footerStart={<GuestInviterCell inviter={item.invitedBy} />}
      footerEnd={
        <TrustAccountCardAction
          rest={
            <TrustAccountTypeCell
              layout="inline"
              trustPurpose={item.trustPurpose}
              generalSaleTransactionType={item.generalSaleTransactionType}
            />
          }
          ctaLabel={t('accounts.row.view')}
          onAction={() => navigate(item.path)}
        />
      }
    />
  );
};
